import { toChildArray } from "preact"
import levenshtein from "js-levenshtein"

class Node {

    constructor(parent, key, value=key) {
        this.key = key
        this.value = value
        this.parent = parent
        this.children = {}
        this.end = false
    }

    word() {
        var node = this
        var word = [this.key];
        while ((node = node.parent) && node.key) {
            word.unshift(node.key)
        }
        return word.join('')
    }

}

const normalize = (str) => {
    return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
}

const traverse = (node, func) => {
    for (let child in node.children) {
        func.apply(this, [node.children[child], func])
        traverse(node.children[child], func)
    }
}

class Trie {
    constructor(values=[], transform=(v) => (v)) {
        this.root = new Node(null, null)
        this.transform = transform
        values.forEach((v) => this.insert(v))
    }

    insert(word, value=word) {
        let node = this.root
        for (let letter of this.transform(value)) {
            var normalizedLetter = normalize(letter)
            if (!node.children[normalizedLetter]) {
                node.children[normalizedLetter] = new Node(node, letter, value)
            }
            node = node.children[normalizedLetter]
        }
        node.end = true
    }

    find(word) {
        let node = this.root
        for (let letter of normalize(word)) {
            if (!node.children[letter]) return null
            node = node.children[letter]
        }
        return node
    }

    contains(word) {
        return (this.find(word) || { end: false }).end
    }

    value(word) {
        return (this.find(word) || { value: null }).value
    }

    traverse(f) {
        var node = this.root
        return traverse(node, f)
    }

    words() {
        const words = []
        this.traverse((node) => {
            if (node.end) words.push(node.word())}
        )
        return words
    }

    values() {
        const values = []
        this.traverse((node) => {
            if (node.end) values.push(node.value)}
        )
        return values
    }

    fuzzy(query, difference=50, matchedChars=0.8) {
        const normalizedQuery = normalize(query || '')
        return normalizedQuery.length > 0 ?
            this.words()
                .map(w => ({ word: w, normalized: normalize(w)}))
                .map(w => ({ ...w,
                    indexOf: w.normalized.indexOf(normalizedQuery),
                    levenshtein: levenshtein(w.normalized, normalizedQuery)
                }))
                .filter(w => w.levenshtein < difference)
                .map(w => {
                    var value = this.find(w.word).value
                    if (typeof value === "string") return value;
                    else return {
                        value,
                        indexOf: w.indexOf,
                        levenshtein: w.levenshtein,
                        matchLength: w.indexOf > -1 ? normalizedQuery.length : 0,
                        included: w.normalized.split('')
                            .filter((c, i, self) => self.indexOf(c) == i)
                            .filter(c => normalizedQuery.indexOf(c) > -1).length / normalizedQuery.length
                    }
                })
                .filter(w => w.matchLength > 0 || w.included > matchedChars) // remove words that don't match at all, or with too big a difference
                .sort((a, b) => ((a.matchLength + b.matchLength > 0) ? a.matchLength <= b.matchLength : a.levenshtein >= b.levenshtein))
            : []
    }

}

export default Trie
